export enum LoadingContainerType {
  PALLET = 'PALLET',
  CONTAINER = 'CONTAINER',
}
